import React, { useMemo } from 'react'
import clsx from 'clsx'
import * as icons from '~/assets/icons'
import { IconName } from '~/assets/types'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography } from '@material-ui/core'

export type DocumentBoxProps = {
  title: string,
  icon: IconName,
  className?: string,
  iconColor?: string,
  description: string,
  textClassName?: string
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    [mutualTheme.breakpoints.down('md')]: {
      alignItems: 'flex-start'
    }
  },
  text: {
    marginLeft: mutualTheme.spacing(1)
  }
})

export const DocumentBox: React.FC<DocumentBoxProps> = (props) => {
  const { title, description, icon, className, textClassName, iconColor } = props
  const classes = useStyles()

  const Icon = useMemo(() => icons[icon], [icon])

  return (
    <Box className={clsx(classes.container, className)}>
      <Icon htmlColor={iconColor} height={24} width={24} />
      <Typography className={clsx(classes.text, textClassName)} variant='airbnbBody1'>
        <b>{title}</b> {description}
      </Typography>
    </Box>
  )
}
